
export default {
  name: 'HomeLedSummary',
  props: {
    tone: {
      type: String,
      default: 'dark',
    },
  },
  methods: {
    keepNumbersTogether(text) {
      return text.replace(/(\d) /g, '$1 ')
    },
  },
}
